/** @jsxImportSource theme-ui */
import classNames from 'classnames';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AppStateContext } from 'api/AppStateContext';
import geonameShapeApi from 'api/GeonameShapeApi';

import esriMap from '.';
import mapAoiLayer from './aoiLayer';
import mapEventDetailView from './eventDetails';
import legend from './legend';
import { updateEventsLayerVisibility } from './map.saga';
import proximalCaseLayer from './proximalCaseLayer';

const MapContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { appState } = useContext(AppStateContext);

  useEffect(() => {
    geonameShapeApi.loadBulkCountries();
    esriMap.renderMap(() => {
      // Events layer gets hidden in certain situations. This ensures if it's supposed to be hidden or shown after first render
      dispatch(updateEventsLayerVisibility());
    });
  }, []);

  useEffect(() => {
    const isAnyPropaxDetailsOpened =
      appState.isProximalDetailsExpandedDELP || appState.isProximalDetailsExpandedEDP;

    isAnyPropaxDetailsOpened ? proximalCaseLayer.show() : proximalCaseLayer.hide();

    mapAoiLayer.setOpacityStateProxpar(isAnyPropaxDetailsOpened);
    mapEventDetailView.setOpacityStateProxpar(isAnyPropaxDetailsOpened);
    legend.toggleProximalLegend(isAnyPropaxDetailsOpened);
  }, [appState.isProximalDetailsExpandedDELP, appState.isProximalDetailsExpandedEDP]);

  useEffect(() => {
    proximalCaseLayer.setProximalShapes(appState.proximalGeonameShapes);
  }, [appState.proximalGeonameShapes]);

  useEffect(() => {
    legend.setTimeframeStartDate(appState.startDate);
  }, [appState.startDate]);

  return (
    <div className={classNames({ 'map-container': true, 'map-hidden': appState.isMapHidden })}>
      <div id="map-div" />
      <div id="map-legend" />
      <div id="gd-global-view-reset" />
    </div>
  );
};

export default MapContainer;
